import React, { Fragment } from "react";
import TextField from "../../common/TextField";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Checkbox from "../../common/Checkbox";
import CustomDatePicker from "../../common/CustomDatePicker";

const PermissionsSection = (props) => (
  <Fragment>
              <h4>{props.translate("sharedPermissions")}</h4>
              <Grid container spacing={2}>
                <Grid item md={3} sm={6} xs={12}>
                  <CustomDatePicker
                    format="DD/MM/YYYY"
                    error={false}
                    label={props.translate("userExpirationTime")}
                    minDate={new Date()} // for check not to select date before today
                    fullWidth={true}
                    value={
                      props.form && props.form.expirationTime
                        ? `${props.form.expirationTime}`
                        : null
                    }
                    onChange={props.handleChange("expirationTime")}
                  />
                  {props.form.expirationTime && (
                    <Tooltip title="Set No Limit">
                      <a
                        href="javascript:void(0)"
                        onClick={(e) => props.setExpirationTime(e)}
                      >
                        No Limit
                      </a>
                    </Tooltip>
                  )}
                </Grid>

                {props.form.userType === 4 && (
                  <Grid item xl={3} sm={6} md={4} xs={12}>
                    <Checkbox
                      checked={
                        (props.unlimitedLimit &&
                          props.unlimitedLimit) ||
                        (props.form.deviceLimit === -1 &&
                          props.form.userLimit === -1 &&
                          props.form.vehicleLimit === -1)
                      }
                      onChange={(e) =>
                        props.changeLimit("unlimitedLimit", e)
                      }
                      label={props.translate("unlimitedLimit")}
                    />
                  </Grid>
                )}

                {props.form &&
                  props.form.userType &&
                  props.form.userType === 1 && (
                    <>
                      <Grid item md={3} sm={6} xs={12}>
                        <TextField
                          error={props.deviceLimitError}
                          id="deviceLimit"
                          label={props.translate("userDeviceLimit")}
                          type="number"
                          placeholder=""
                          value={props.form.deviceLimit ?? 0}
                          onChange={props.handleChange("deviceLimit")}
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          helperText={
                            props.deviceLimitError &&
                            props.unitsLimitsMeaasge
                              ? props.translate(
                                  props.unitsLimitsMeaasge,
                                )
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item md={3} sm={6} xs={12}>
                        <TextField
                          id="vehicleLimit"
                          error={props.vehicleLimitError}
                          label={props.translate("userVehicleLimit")}
                          type="number"
                          placeholder=""
                          value={props.form.vehicleLimit ?? 0}
                          onChange={props.handleChange("vehicleLimit")}
                          variant="outlined"
                          margin="dense"
                          fullWidth
                        />
                      </Grid>
                    </>
                  )}
                {props.form &&
                  props.form.userType &&
                  props.form.userType !== 1 && (
                    <>
                      <Grid item md={3} sm={6} xs={12}>
                        <TextField
                          error={props.deviceLimitError}
                          id="deviceLimit"
                          label={props.translate("userDeviceLimit")}
                          type="number"
                          placeholder=""
                          value={props.form.deviceLimit ?? 0}
                          onChange={props.handleChange("deviceLimit")}
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          helperText={
                            props.deviceLimitError &&
                            props.unitsLimitsMeaasge
                              ? props.translate(
                                  props.unitsLimitsMeaasge,
                                )
                              : ""
                          }
                          // helperText={props.logInUser.userType !==-1 ?
                          //   `Remaining Units ${props.form.deviceLimit>0?props.deviceLimit - props.form.deviceLimit:props.deviceLimit }`
                          //     : null}
                          // helperText={
                          //   props.deviceLimitError
                          //     ? props.translate(
                          //         props.unitsLimitsMeaasge
                          //       )
                          //     : props.addOption && props.logInUser.userType !==-1 ?
                          //     `Remaining Units ${props.form.deviceLimit>0?props.deviceLimit - props.form.deviceLimit:props.deviceLimit }`
                          //     : props.editOption && props.selectedUser.parentId !==1 ?
                          //     `Remaining Units ${props.form.deviceLimit>0?props.deviceLimit - props.form.deviceLimit:props.deviceLimit }`
                          //    : null
                          // }
                          // helperText={
                          //   props.deviceLimitError
                          //     ? props.translate(
                          //         props.unitsLimitsMeaasge
                          //       )
                          //     : props.addOption &&
                          //       props.logInUser.userType !== -1
                          //     ? `Remaining Units ${
                          //         props.form.deviceLimit > 0
                          //           ? props.deviceLimit -
                          //             props.form.deviceLimit
                          //           : props.deviceLimit
                          //       }`
                          //     : props.editOption &&
                          //       props.selectedUser.parentId !== 1
                          //     ? `Created Units ${props.createdUnits}`
                          //     : null
                          // }
                        />
                        {!props.deviceLimitError &&
                          props.editOption &&
                          props.form.deviceLimit !== -1 &&
                          (props.selectedUnitsLimits.count ||
                            props.selectedUnitsLimits.count === 0) && (
                            <Tooltip
                              title={props.translate("remainingUnits")}
                            >
                              <a>
                                {props.translate("remaining")} :{" "}
                                {props.form.deviceLimit -
                                  (props.selectedUnitsLimits.count +
                                    props.selectedUnitsLimits
                                      .reserveLimit)}
                              </a>
                            </Tooltip>
                          )}
                      </Grid>
                      {props.logInUser.userType !== 2 && (
                        <Grid item md={3} sm={6} xs={12}>
                          <TextField
                            id="userLimit"
                            error={props.userLimitError}
                            label={props.translate("userUserLimit")}
                            type="number"
                            placeholder=""
                            value={props.form.userLimit || 3}
                            onChange={props.handleChange("userLimit")}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            // helperText={
                            //   props.userLimitError
                            //     ? props.translate(
                            //         props.usersLimitsMeaasge
                            //       )
                            //     : props.addOption &&
                            //       props.logInUser.userType !== -1
                            //     ? `Remaining Users ${
                            //         props.form.userLimit > 0
                            //           ? props.usersLimit -
                            //             props.form.userLimit
                            //           : props.usersLimit
                            //       }`
                            //     : props.editOption &&
                            //       props.selectedUser.parentId !== 1
                            //     ? `Created Users ${props.createdUsers}`
                            //     : null
                            // }

                            // helperText={props.logInUser.userType !==-1 ?
                            //   `Remaining Users ${props.form.userLimit>0 ? props.usersLimit - props.form.userLimit:props.usersLimit }`
                            //     : null
                            // }
                          />
                          {!props.userLimitError &&
                            props.editOption &&
                            props.form.userLimit !== -1 &&
                            (props.selectedUserLimits.count ||
                              props.selectedUserLimits.count === 0) && (
                              <Tooltip
                                title={props.translate("remainingUser")}
                              >
                                <a>
                                  {props.translate("remaining")} :{" "}
                                  {props.form.userLimit -
                                    (props.selectedUserLimits.count +
                                      props.selectedUserLimits
                                        .reserveLimit)}
                                </a>
                              </Tooltip>
                            )}
                        </Grid>
                      )}
                      {props.logInUser.userType !== 2 && (
                        <Grid item md={3} sm={6} xs={12}>
                          <TextField
                            id="vehicleLimit"
                            error={props.vehicleLimitError}
                            label={props.translate("userVehicleLimit")}
                            type="number"
                            placeholder=""
                            value={props.form.vehicleLimit ?? 0}
                            onChange={props.handleChange("vehicleLimit")}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            // helperText={
                            //   props.vehicleLimitError
                            //     ? props.translate(
                            //         props.vehicleLimitsMeaasge
                            //       )
                            //     : props.addOption &&
                            //       props.logInUser.userType !== -1
                            //     ? `Remaining Vehicles ${
                            //         props.form.vehicleLimit > 0
                            //           ? props.vehicleLimit -
                            //             props.form.vehicleLimit
                            //           : props.vehicleLimit
                            //       }`
                            //     : props.editOption &&
                            //       props.selectedUser.parentId !== 1
                            //     ? `Created Vehicles ${props.createdUsers}`
                            //     : null
                            // }

                            // helperText={props.logInUser.userType !==-1 ?
                            //   `Remaining Users ${props.form.userLimit>0 ? props.usersLimit - props.form.userLimit:props.usersLimit }`
                            //     : null
                            // }
                          />
                          {!props.vehicleLimitError &&
                            props.editOption &&
                            props.form.vehicleLimit !== -1 &&
                            (props.selectedUserLimits.count ||
                              props.selectedUserLimits.count === 0) && (
                              <Tooltip
                                title={props.translate("remainingUser")}
                              >
                                <a>
                                  {props.translate("remaining")} :{" "}
                                  {props.form.vehicleLimit -
                                    (props.selectedUserLimits.count +
                                      props.selectedUserLimits
                                        .reserveLimit)}
                                </a>
                              </Tooltip>
                            )}
                        </Grid>
                      )}
                    </>
                  )}
              </Grid>
  </Fragment>
);

export default PermissionsSection;
